// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2S3Q8","errors":"Errors_errors__2fYHC"};